<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      height: 100%;
      min-height: 62px;
    "
  >
    <div>
      {{ item.dob ? item.dob : '-' }}
    </div>
    <div>
      {{ item.gender ? item.gender : '-' }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object
  }
}
</script>
